<template>
  <div class="policy-page">
    <div v-if="loading" class="policy-tip">loading...</div>
    <div v-else-if="errorText" class="policy-tip">{{ errorText }}</div>
    <div ref="container" class="docx-preview" v-show="!errorText" />
  </div>
</template>

<script>
import * as docxPreview from "docx-preview/dist/docx-preview.js"

const OSS_BASE_URL = "https://komi-pord.oss-eu-central-1.aliyuncs.com/vue/"

export default {
  name: "PolicyDocxViewer",
  data() {
    return {
      docUrl: "",
      errorText: "",
      loading: false,
      resizeObs: null
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.initDocUrl()
        this.renderDoc()
      }
    }
  },
  mounted() {
    this.renderDoc()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.fitToScreen)
    if (this.resizeObs) {
      this.resizeObs.disconnect()
      this.resizeObs = null
    }
  },
  methods: {
    resolveDocUrl(p) {
      const path = String(p || "").replace(/^\/+/, "")
      return OSS_BASE_URL + path
    },
    initDocUrl() {
      const doc = (this.$route && this.$route.params && this.$route.params.doc) ? String(this.$route.params.doc) : ""
      this.errorText = ""
      if (doc === "user") {
        this.docUrl = this.resolveDocUrl("policy/User.docx")
        return
      }
      if (doc === "private") {
        this.docUrl = this.resolveDocUrl("policy/Private.docx")
        return
      }
      this.docUrl = ""
      this.errorText = "文档不存在"
    },
    fitToScreen() {
      const container = this.$refs.container
      if (!container) return

      const wrapper = container.querySelector(".docx-wrapper") || container.firstElementChild
      const doc = container.querySelector(".docx") || (wrapper && wrapper.querySelector(":scope > *")) || container.firstElementChild
      if (!wrapper || !doc) return

      doc.style.transform = "none"

      const firstPage = doc.querySelector(".page")
      const originalWidth = (firstPage && firstPage.getBoundingClientRect().width) || doc.getBoundingClientRect().width
      const originalHeight = doc.getBoundingClientRect().height || (firstPage && firstPage.getBoundingClientRect().height) || 0
      if (!originalWidth || !originalHeight) return

      const vw = document.documentElement.clientWidth
      const cs = getComputedStyle(container)
      const paddingLeft = parseFloat(cs.paddingLeft || "0")
      const paddingRight = parseFloat(cs.paddingRight || "0")
      const available = vw - paddingLeft - paddingRight

      const scale = Math.min(1.5, available / originalWidth)
      doc.style.transformOrigin = "top left"
      doc.style.transform = `scale(${scale})`
      wrapper.style.height = `${originalHeight * scale}px`
      wrapper.style.width = `${available}px`
    },
    renderDoc() {
      if (!this.docUrl) {
        return
      }
      this.loading = true
      const container = this.$refs.container
      if (!container) {
        this.loading = false
        return
      }

      window.removeEventListener("resize", this.fitToScreen)
      if (this.resizeObs) {
        this.resizeObs.disconnect()
        this.resizeObs = null
      }
      container.innerHTML = ""

      fetch(this.docUrl, { cache: "no-store" })
        .then(res => {
          if (!res || !res.ok) {
            const code = res ? res.status : 0
            throw new Error(String(code || "load_failed"))
          }
          return res.arrayBuffer()
        })
        .then(arrayBuffer => docxPreview.renderAsync(arrayBuffer, container, undefined, {
          inWrapper: true,
          ignoreWidth: false,
          ignoreHeight: false,
          breakPages: true,
          ignoreLastRenderedPageBreak: true
        }))
        .then(() => {
          this.loading = false
          requestAnimationFrame(this.fitToScreen)
          setTimeout(this.fitToScreen, 50)
          const doc = container.querySelector(".docx")
          if (doc && typeof ResizeObserver !== "undefined") {
            this.resizeObs = new ResizeObserver(() => requestAnimationFrame(this.fitToScreen))
            this.resizeObs.observe(doc)
          }
          window.addEventListener("resize", this.fitToScreen)
        })
        .catch(() => {
          this.loading = false
          this.errorText = "文档加载失败"
        })
    }
  }
}
</script>

<style>
.policy-page {
  width: 100vw;
  max-width: 100vw;
  min-height: 100vh;
  background: #fff;
}

.policy-tip {
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.8);
}

.docx-preview {
  width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  padding: 0;
  background: #fff;
  font-size: 16px;
  line-height: 1.6;
}

.docx-preview .docx-wrapper {
  background: #fff !important;
  padding: 0 !important;
  margin: 0 !important;
  position: relative !important;
  width: 100% !important;
  overflow: visible !important;
}

.docx-preview .docx {
  margin: 0 !important;
  transform-origin: top left !important;
  position: absolute !important;
  top: 0;
  left: 0;
  will-change: transform;
}

.docx-preview .page {
  margin: 0 !important;
  box-shadow: none !important;
  width: auto !important;
}

@media (max-width: 768px) {
  .docx-preview { font-size: 16px; }
}
@media (max-width: 480px) {
  .docx-preview { font-size: 15px; }
}
</style>
